import type { Outline } from "../math/samplePath";

// A single closed outer contour, inspired by the supplied rounded penguin.
// Its interior markings are revealed only after the Fourier trace completes.
const start = { x: 627, y: 56 };
const segments: readonly (readonly [number, number, number, number, number, number])[] = [
  [795, 56, 928, 162, 954, 309],
  [964, 372, 948, 431, 946, 472],
  [941, 514, 960, 536, 996, 579],
  [1067, 663, 1126, 750, 1127, 802],
  [1128, 882, 1060, 840, 1001, 786],
  [1005, 933, 978, 1041, 873, 1080],
  [899, 1102, 919, 1128, 913, 1145],
  [906, 1174, 880, 1167, 856, 1150],
  [846, 1182, 822, 1190, 793, 1160],
  [770, 1182, 736, 1180, 729, 1154],
  [720, 1132, 742, 1103, 761, 1086],
  [677, 1136, 560, 1135, 494, 1104],
  [518, 1125, 528, 1150, 520, 1162],
  [503, 1181, 476, 1166, 461, 1156],
  [440, 1195, 411, 1183, 398, 1157],
  [365, 1178, 334, 1162, 342, 1134],
  [348, 1111, 364, 1093, 382, 1079],
  [281, 1047, 249, 948, 253, 787],
  [195, 845, 126, 885, 128, 803],
  [127, 729, 196, 620, 274, 536],
  [303, 508, 314, 487, 307, 450],
  [277, 316, 309, 208, 391, 130],
  [454, 67, 538, 56, 627, 56],
];

export const penguin: Outline = segments.map((segment, index) => ({
  from: index === 0 ? start : { x: segments[index - 1][4], y: segments[index - 1][5] },
  c1: { x: segment[0], y: segment[1] },
  c2: { x: segment[2], y: segment[3] },
  to: { x: segment[4], y: segment[5] },
}));

export const penguinBodyPath =
  `M ${start.x} ${start.y} ` +
  segments.map(([x1, y1, x2, y2, x, y]) => `C ${x1} ${y1} ${x2} ${y2} ${x} ${y}`).join(" ") +
  " Z";

// The right flipper is a separate layer only in the finished character.
// The Fourier contour above stays fixed and mathematically unchanged.
export const penguinRestBodyPath =
  `M ${start.x} ${start.y} ` +
  [...segments.slice(0, 2), [970, 560, 993, 680, 1001, 786], ...segments.slice(5)]
    .map(([x1, y1, x2, y2, x, y]) => `C ${x1} ${y1} ${x2} ${y2} ${x} ${y}`)
    .join(" ") + " Z";

export const penguinRightFlipperPath =
  "M 946 472 C 941 514 960 536 996 579 C 1067 663 1126 750 1127 802 " +
  "C 1128 882 1060 840 1001 786 C 970 700 925 625 905 560 " +
  "C 912 520 931 490 946 472 Z";

